import * as angular from 'angular';
import * as _ from 'lodash';

import {States} from "../../shared/config/constant.module";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import AlertServiceName, {AlertRoleService} from '../../services/alertRoles/alertRoleService';
import template from './alertRole.tpl.html';

let requires = [NotifyServiceName, LoaderServiceName, AlertServiceName];

interface IalertrolesController {
    alertRoles: apsViewModels.AlertRoleMapping[];
    postingAlerts: boolean;
    cancel(): void;
    getRoles(): void;
}

class AlertRolesCtrl implements IalertrolesController {
    constructor (loaderService: LoaderService,
                  notifyService: NotifyService,
                  AlertRolesService: AlertRoleService,
                  $modal: mm.foundation.modal,
                  $timeout: angular.ITimeoutService) {
        this.AlertRolesService = AlertRolesService;
        this.$timeout = $timeout;
        this.notifyService = notifyService;
        this.getRoles();
    }

    alertRoles: apsViewModels.AlertRoleMapping[] = new Array<apsViewModels.AlertRoleMapping>();
    postingAlerts: boolean;
    private AlertRolesService: AlertRoleService;
    private notifyService: NotifyService;
    private $timeout: angular.ITimeoutService;

    cancel = function() {}  

    getRoles = function() {  
        this.AlertRolesService.getalertroles()
          .then((data:apsViewModels.AlertRoleMapping[]) => {
            this.alertRoles = data;
          });
    };

    saveRoles = function () {
      if (!this.postingAlerts) {
        this.postingAlerts = true;
        let command = { alertRoles: Array<apsCommands.SaveAlertRoleMapping>() };
  
        _.forEach(this.alertRoles, (ar:apsViewModels.AlertRoleMapping) =>{
            _.forEach((ar.plants), (arp: apsViewModels.AlertRolePlant) => {
              command.alertRoles.push({
                  alertRoleMappingId: arp.alertRoleMappingId,
                  Active: arp.active
                });
            });
          }
        );  
  
        this.AlertRolesService.postalertroles(command)
          .finally(() => {
            this.$timeout(() => {   
              this.getRoles(); 
              this.postingAlerts = false;
            }, 1500);   
          })
          .then(() => {
            this.notifyService.success('Alert Roles - Updated successfully');        
          }, this.notifyService.handleApiErrors)
      }
    }
}

export default angular.module('aps.controller.alertroles', requires)
  .config(function($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.ALERTROLES,
      url: '/admin/alertroles',
      controller: 'AlertRolesCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Alert Roles Enable/Disable for plant',
        authorizeAdmin: true
      }
    });
  })
  .controller('AlertRolesCtrl', AlertRolesCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/alertRoles/alertRole.controller.ts